// Url.js

export const isHttpUrl = (value) => {
    if (!value) return false;
    try {
        const url = new URL(String(value).trim());
        return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
        return false;
    }
};

export const isUrlInputValid = (value) => {
    const trimmed = String(value ?? '').trim();
    return trimmed === '' || isHttpUrl(trimmed);
};

export const normalizeUrlForOpen = (value) => {
    const trimmed = String(value ?? '').trim();
    if (!trimmed) return '';

    const hasScheme = /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(trimmed);
    return hasScheme ? trimmed : `https://${trimmed}`;
};
